import { format, setDay } from "date-fns"

export default function getDaysOfWeekInfo() {
  const daysOfWeek = []

  for (let i = 1; i <= 7; i++) {
    const dayValue = i % 7
    const dayObj = setDay(new Date(), dayValue)

    daysOfWeek.push({
      label: format(dayObj, "EEEEEE"),
      value: dayValue,
    })
  }

  return daysOfWeek
}
